import React from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { DOWNLOAD_URL } from '../constants/stores'
import { useLocale } from '../contexts/LocaleContext'

function DownloadQR() {
  const { t } = useLocale()

  return (
    <div className="download-qr">
      <div className="download-qr-code">
        <QRCodeSVG value={DOWNLOAD_URL} size={88} bgColor="#ffffff" fgColor="#0b1020" level="M" />
      </div>
      <div className="download-qr-text">
        <strong>{t.download.qrTitle}</strong>
        <span>{t.download.qrSubtitle}</span>
      </div>
    </div>
  )
}

export default DownloadQR
